import { RadioQuestion } from "~/types/questionTypes"
import { redcapChoicesToRadioOptions } from "~/util/redcapChoicesToRadioOptions"
import RadioButton from "~/components/RadioButton"

type RadioFieldProps = {
  value: string | string[]
  question: RadioQuestion
  onChange: (newData: string | string[]) => void
  className?: string
}

export const RadioField = (props: RadioFieldProps): JSX.Element => {
  const {
    question: { fieldName, selectChoicesOrCalculations },
    value,
    onChange,
    className
  } = props

  const optionsWithValues = redcapChoicesToRadioOptions(
    selectChoicesOrCalculations
  )

  return (
    <div className={`${className} flex flex-col gap-1.5`}>
      {optionsWithValues.map(({ label, value: optionValue }) => (
        <div key={fieldName + optionValue}>
          <RadioButton
            required
            checked={value === optionValue}
            key={fieldName + optionValue}
            name={fieldName}
            label={label}
            value={optionValue}
            onChange={(event) => {
              onChange(event.target.value)
            }}
          />
        </div>
      ))}
    </div>
  )
}
